/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { LiteralsWords } from '../../../i18n/literals.model';

@Component({
    selector: 'tgv-show-more-button',
    standalone: false,
    templateUrl: './show-more-button.component.html',
    styleUrls: ['./show-more-button.component.css']
})
export class ShowMoreButtonComponent {
    @Input() hasNext;
    @Input() loadingSearch;
    @Output() showMore = new EventEmitter();
    literals: LiteralsWords;

    constructor(private literalsService: LiteralsService) {
        this.literals = this.literalsService.getLiteralModule();
    }

    showMoreAction(): void {
        this.showMore.emit();
    }
}
